interface ButtonsProps {
  children: React.ReactNode
  direction?: 'ph-row' | 'ph-col'
  className?: string
}

export const Buttons = ({
  direction = 'ph-row',
  className = '',
  children,
}: ButtonsProps) => {
  return (
    <div className={`d-flex gap-2 ${direction} ${className}`}>
      {children}
    </div>
  )
}
